import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import thunk from 'redux-thunk';
import app from './reducers';
import { historyMiddleware } from './Middlewares/History.middleware';

import LoadingDatePicker from './Containers/LoadingDatePicker.container';
import MiniCartContainer from './Containers/MiniCart.container';
import QuickSearchContainer from './Containers/QuickSearch.container';
import NavigationContainer from './Containers/Navigation.container';
import FacetedSearchContainer from './Containers/FacetedSearch.container';
import FacetedSearchCompactContainer from './Containers/FacetedSearchCompact.container';
import NotificationContainer from './Containers/Notification.container';
import DynamicComponent from './Components/DynamicComponent';
import GenericGridViewContainer from './Containers/GenericGridView.container';
import FieldConfiguratorContainer from './Containers/FieldConfigurator.container';
import WebsiteSelectorContainer from './Containers/WebsiteSelector.container';
import SelectOrganizationContainer from './Containers/SelectOrganization.container';
import DropZoneContainer from './Containers/DropZone.container';
import OrderScanningContainer from './Containers/OrderScanning.container';
import HeaderInformationDataContainer from './Containers/headerInformationData.container';

//import tippy from './Vendor/tippy.js'; 
import tippy from 'tippy.js';
//import ripple from './Vendor/ripple.js';

//import Glide from './Vendor/glide.js';
import Glide, { Breakpoints } from './Vendor/glide.js';

let buyButtonsLoaded = false;

document.addEventListener("DOMContentLoaded", function () {
    tippy('.tooltip', {
        content: '',
        allowHTML: true,
        trigger: 'click',
    });
});

window.__litium = window.__litium || {};
const preloadState = window.__litium.preloadState || {};
// use the parent page's store if possible, so the iframe will share the same store with the parent context.
// this to makes for example the Reorder button in My Page page to update the state and reload the mini cart
// when reorder action happens.
const store = window.__litium.store = window.__litium.store || (window.parent.__litium && window.parent.__litium.store)
    || createStore(app, preloadState, composeWithDevTools(applyMiddleware(thunk, historyMiddleware)));
window.__litium = {
    ...window.__litium,
    bootstrapComponents: () => {
        // bootstrap React components, in case the HTML response we receive from the server
        // has React components. ReactDOM.render performs only an update on previous rendered
        // components and only mutate the DOM as necessary to reflect latest React element.
        bootstrapComponents();
    },
    cache: {}, // for storing cache data for current request
};

window.addEventListener('load', function () {
    //let gliderEls = document.querySelector('.glider-custom');

    //new Glide('.glider-custom').mount(
    //    {
    //        type: 'carousel',
    //        startAt: 0,
    //        perView: 3
    //    }
    //    );

    let gliderEls = document.querySelectorAll('.glider-custom');
    if (gliderEls) {
        const conf = {
            type: 'slider',
            gap: 0,
            autoplay: 0,
            startAt: 0,
            perView: 4,
            breakpoints: {
                1024: {
                    perView: 3
                },
                640: {
                    perView: 2
                }
            },
            animationDuration: 600,
            animationTimingFunc: 'ease-out',

        }

        gliderEls.forEach((gliderEl) => {
            new Glide(gliderEl, conf).mount();
        });
    }
    //        window.glides = new Glider(gliderEl,
    //            {
    //                // Mobile-first defaults
    //                slidesToShow: 2,
    //                slidesToScroll: 1,
    //                scrollLock: true,
    //                draggable: true,
    //                dots: '.resp-dots',
    //                arrows: {
    //                    prev: '.glider-prev',
    //                    next: '.glider-next'
    //                },
    //                responsive: [
    //                    {
    //                        // screens greater than >= 775px
    //                        breakpoint: 775,
    //                        settings: {
    //                            // Set to `auto` and provide item width to adjust to viewport
    //                            slidesToShow: 3,
    //                            slidesToScroll: 1,
    //                            itemWidth: 150,
    //                            duration: 0.25
    //                        }
    //                    }, {
    //                        // screens greater than >= 1024px
    //                        breakpoint: 1024,
    //                        settings: {
    //                            slidesToShow: 4,
    //                            slidesToScroll: 1,
    //                            itemWidth: 150,
    //                            duration: 0.25
    //                        }
    //                    }
    //                ]
    //            });
    //    });
    // }

});

const bootstrapComponents = () => {

    // Loading date picker
    const loadingDatePickerEl = document.getElementById('loadingDatePicker');
    if (loadingDatePickerEl) {
        //const LoadingDatePicker = DynamicComponent({
        //    loader: () => import('./Containers/LoadingDatePicker.container')
        //});
        ReactDOM.render(
            <Provider store={store}>
                <LoadingDatePicker />
            </Provider>,
            loadingDatePicker
        );
    }

    if (document.getElementById('miniCart')) {
        ReactDOM.render(
            <Provider store={store}>
                <MiniCartContainer />
            </Provider>,
            document.getElementById('miniCart')
        );
    }
    if (document.getElementById('quickSearch')) {
        ReactDOM.render(
            <Provider store={store}>
                <QuickSearchContainer />
            </Provider>,
            document.getElementById('quickSearch')
        );
    }
    if (document.getElementById('navbar')) {
        ReactDOM.render(
            <Provider store={store}>
                <NavigationContainer />
            </Provider>,
            document.getElementById('navbar')
        );
    }
    if (document.getElementById('websiteSelector')) {
        ReactDOM.render(
            <Provider store={store}>
                <WebsiteSelectorContainer />
            </Provider>,
            document.getElementById('websiteSelector')
        );
    }
    if (document.getElementById('facetedSearch')) {
        ReactDOM.render(
            <Provider store={store}>
                <FacetedSearchContainer />
            </Provider>,
            document.getElementById('facetedSearch')
        );
    }
    if (document.getElementById('facetedSearchCompact')) {
        ReactDOM.render(
            <Provider store={store}>
                <FacetedSearchCompactContainer />
            </Provider>,
            document.getElementById('facetedSearchCompact')
        );
    }
    if (document.getElementById('globalNotification')) {
        ReactDOM.render(
            <Provider store={store}>
                <NotificationContainer />
            </Provider>,
            document.getElementById('globalNotification')
        );
    }

    if (document.getElementById('myPagePersons')) {
        const PersonList = DynamicComponent({
            loader: () => import('./Containers/PersonList.container')
        });
        ReactDOM.render(
            <Provider store={store}>
                <PersonList />
            </Provider>,
            document.getElementById('myPagePersons')
        );
    }
    if (document.getElementById('myPageAddresses')) {
        const AddressList = DynamicComponent({
            loader: () => import('./Containers/AddressList.container')
        });
        ReactDOM.render(
            <Provider store={store}>
                <AddressList />
            </Provider>,
            document.getElementById('myPageAddresses')
        );
    }
    if (document.getElementById('checkout')) {
        const Checkout = DynamicComponent({
            loader: () => import('./Containers/Checkout.container')
        });
        ReactDOM.render(
            <Provider store={store}>
                <Checkout />
            </Provider>,
            document.getElementById('checkout')
        );
    }

    if (document.getElementById('lightBoxImages')) {
        const LightboxImages = DynamicComponent({
            loader: () => import('./Containers/LightboxImages.container')
        });
        const rootElement = document.getElementById('lightBoxImages');
        const rootElementVideos = document.getElementById('lightBoxVideos');
        const images = Array.from(rootElement.querySelectorAll('a')).map(img => (img.dataset.src));
        const videos = Array.from(rootElementVideos.querySelectorAll('span a')).map(a => (a.href));
        const concatArray = images.concat(videos);

        const images2 = Array.from(rootElement.querySelectorAll('a')).map(img => ({ src: img.dataset.src, type: "image" }));
        const videos2 = Array.from(rootElementVideos.querySelectorAll('span a')).map(a => ({ src: a.getAttribute("data-image"), type: "video" }));

        const thumbnails = Array.from(rootElement.querySelectorAll('a img')).map(img => ({ src: img.src, type: "image" }));
        const concatArray2 = thumbnails.concat(videos2);



        const concat = images.concat(videos);
        ReactDOM.render(
            <Provider store={store}>
                <LightboxImages thumbnails={concatArray2} videos={videos2} items={concatArray} />
            </Provider>,
            document.getElementById('lightBoxImages')
        );
    }

    if (document.querySelectorAll('.slider').length > 0) {
        const Slider = DynamicComponent({
            loader: () => import('./Components/Slider')
        });
        Array.from(document.querySelectorAll('.slider')).forEach((slider, index) => {
            const values = [...slider.querySelectorAll('.slider__block')].map(block => {

                let textbelowmobile = false;
                if (block.dataset.textbelowmobile.toLowerCase() === 'true') {
                    textbelowmobile = true;
                }

                let textstyle = { color: "inherit" };
                let textStyleString = block.dataset.textstyle + ' ' + block.dataset.ctastyle;
                textstyle = returnAsObject(textStyleString);

                let headersizecss = { color: "inherit" };
                let headersizecssString = block.dataset.headersizecss;
                headersizecss = returnAsObject(headersizecssString);

                return ({
                    image: block.dataset.image,
                    url: block.dataset.url,
                    text: block.dataset.text,
                    tabletimageurl: block.dataset.tabletimageurl,
                    mobileimageurl: block.dataset.mobileimageurl,
                    bannerimageclassdesktop: "slider__image " + block.dataset.bannerimageclassdesktop,
                    bannerimageclasstablet: "slider__image " + block.dataset.bannerimageclasstablet,
                    blocktitle: block.dataset.blocktitle,
                    blocktext: block.dataset.blocktext,
                    textstyle: textstyle,
                    ctastyle: block.dataset.ctastyle,
                    headersizecss: headersizecss,
                    textbelowmobile: textbelowmobile,
                })
            });
            if (values.length > 0) {
                ReactDOM.render(
                    <Slider values={values} />,
                    slider
                );
            }
        });
    }

    if (document.querySelectorAll('buy-button').length > 0) {
        const BuyButton = DynamicComponent({
            loader: () => import('./Containers/BuyButton.Container')
        });
        Array.from(document.querySelectorAll('buy-button')).forEach((button) => {
            const { articleNumber, quantityFieldId, href, cssClass } = button.dataset;

            const label = button.innerText;
            ReactDOM.render(
                <Provider store={store}>
                    <BuyButton {...{ label, articleNumber, quantityFieldId, href, cssClass }} />
                </Provider>,
                button
            );
        });
    }

    if (document.querySelectorAll('reorder-button').length > 0) {
        const ReorderButton = DynamicComponent({
            loader: () => import('./Containers/ReorderButton.Container')
        });
        Array.from(document.querySelectorAll('reorder-button')).forEach((button) => {
            const { cssClass, orderId, title } = button.dataset;
            const label = button.innerText;
            ReactDOM.render(
                <Provider store={store}>
                    <ReorderButton {...{ label, title, cssClass, orderId }} />
                </Provider>,
                button
            );
        });
    }

    // Campaign - Called from Navigation
    // const campaignClass = '.campaignSelector';
    //const campaignEl = document.querySelectorAll(campaignClass);
    //if (campaignEl.length > 0) {
    //    const Campaign = DynamicComponent({
    //        loader: () => import('./Containers/Campaign.container')
    //    });
    //    Array.from(campaignEl).forEach((el, index) => {
    //        const elementData = { ...el.dataset };
    //        const label = el.innerText;
    //        if (elementData.hasmegamenu && elementData.hasmegamenu === "true") {
    //            elementData.hasmegamenu = true;
    //        } else {
    //            elementData.hasmegamenu = false;
    //        }

    //        ReactDOM.render(
    //            <Provider store={store}>
    //                <Campaign {...{ elementData }} />
    //            </Provider>,
    //            el
    //        );
    //    });
    //}


    const articleRelationAddButtonEl = document.getElementById('articleRelationAddButton');
    if (articleRelationAddButtonEl) {
        const ArticleRelationAddButtonEl = DynamicComponent({
            loader: () => import('./Containers/ArticleRelationAddButton.container')
        });
        ReactDOM.render(
            <Provider store={store}>
                <ArticleRelationAddButtonEl />
            </Provider>,
            articleRelationAddButtonEl
        );
    }



    if (document.getElementById('cookieBar')) {
        const CookieWarning = DynamicComponent({
            loader: () => import('./Components/CookieWarning')
        });
        ReactDOM.render(
            <Provider store={store}>
                <CookieWarning />
            </Provider>,
            document.getElementById('cookieBar')
        );
    }
    if (document.getElementById('selectOrganization')) {
        ReactDOM.render(
            <Provider store={store}>
                <SelectOrganizationContainer />
            </Provider>,
            document.getElementById('selectOrganization')
        );
    }


    document.querySelectorAll('[data-field-configuration]').forEach((elem) => {
        ReactDOM.render(
            <Provider store={store}>
                <FieldConfiguratorContainer type={elem.dataset.fieldConfiguration} />
            </Provider>,
            elem,
        );
    });

    document.querySelectorAll('[data-grid-view]').forEach((elem) => {
        console.log(elem.dataset.gridView);
        ReactDOM.render(
            <Provider store={store}>
                <GenericGridViewContainer type={elem.dataset.gridView} />
            </Provider>,
            elem,
        );
    });


    document.querySelectorAll('[data-dropzone]').forEach((elem) => {
        ReactDOM.render(
            <Provider store={store}>
                <DropZoneContainer type={elem.dataset.dropzone} />
            </Provider>,
            elem,
        );
    });

    document.querySelectorAll('[data-orderscanning]').forEach((elem) => {
        ReactDOM.render(
            <Provider store={store}>
                <OrderScanningContainer />
            </Provider>,
            elem,
        );
    });


    if (document.getElementById('headerInformationData')) {
        ReactDOM.render(
            <Provider store={store}>
                <HeaderInformationDataContainer />
            </Provider>,
            document.getElementById('headerInformationData')
        );
    }
}

bootstrapComponents();

function returnAsObject(str) {
    var textstyle = { fontWeight: "normal" };
    if (str.length > 5) {
        textstyle = '{' + str + '}';
        textstyle = textstyle.replace(",}", "}").replace(/'/g, '"');
        try {
            return JSON.parse(textstyle);
        }
        catch (err) {
            return { fontWeight: "normal" };
        }
    }
}
